import qs from 'qs';
import http, { defaultConfig, getUniversityUrl } from './http';
import { activity } from './mappers';
import { TFunction } from 'i18next';

export interface FetchActivityLogOptions {
  page?: number;
  limit?: number;
  fromDate?: string;
  toDate?: string;
  findVariantById?: any;
  t: TFunction;
}

export const fetchActivityLogs = async ({
  page = 1,
  limit = 200,
  findVariantById = undefined,
  fromDate,
  toDate,
  t
}: FetchActivityLogOptions) => {
  const baseURL = getUniversityUrl();
  const queries = qs.stringify({ page, size: limit, fromDate, toDate });
  const url = `/rest/users/activity-logs?${queries}`;
  const res = (await (http.get<APIResponse<ActivityReportEntity[]>>(url, {
    ...defaultConfig(baseURL),
    timeout: 120000
  })));
  
  return {
    total: res.data.payload.totalElements,
    items: activity.mapItems(res.data.payload.content ?? [], findVariantById, t),
    
  };
};
